import { mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/loading/index.vue'

export default {
  components: {
    Loading
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      e1: true,
      e2: true,
      name: '',
      email: '',
      password: '',
      currentPassword: '',
      idClient: '',
      idUserType: null,
      emailRules: [
        (v) => !!v || 'E-mail é obrigatório',
        (v) => /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail precisa ser válido'
      ],
      dialog: false,
      isLoading: false,
      usersType: [
        { id: 1, name: 'Suporte' },
        { id: 2, name: 'Vendedor' },
        { id: 3, name: 'Operador' },
        { id: 4, name: 'Implantador' },
        { id: 5, name: 'Operador - Guide' },
        { id: 6, name: 'Financeiro' },
        { id: 7, name: 'Usuário POC' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedUser',
      'getterAccount'
    ]),
    isEditingUser () {
      return Object.keys(this.getterSelectedUser).length > 0
    },
    isDisabled () {
      let condition = this.name === '' || !this.email || this.idUserType === null

      if (!this.isEditingUser) {
        condition = condition || this.password === ''
      }

      return condition
    }
  },
  mounted () {
    this.setUserInfo()
  },
  beforeDestroy () {
    this.SELECT_USER()
  },
  methods: {
    ...mapActions([
      'actionAddUser',
      'actionGetAllUsers',
      'actionEditUser',
      'actionChangePassword',
      'actionRemoveUser',
      'actionGetAllUsers'
    ]),
    ...mapMutations([
      'SELECT_USER'
    ]),
    setUserInfo () {
      if (this.isEditingUser) {
        this.name = this.getterSelectedUser.name
        this.email = this.getterSelectedUser.email
        this.idUserType = this.getterSelectedUser.idUserType
      }

      this.dialog = true
    },
    onClickMainButton () {
      if (this.isEditingUser) {
        this.editUser()
      } else {
        this.addUser()
      }
    },
    addUser () {
      const params = {
        email: this.email,
        name: this.name,
        password: this.password,
        idUserType: this.idUserType,
        idClient: this.getterAccount.idClient,
        idUserLogged: this.getterAccount.idUser
      }

      this.isLoading = true

      this.actionAddUser(params)
        .then(() => {
          this.actionGetAllUsers(this.getterAccount.idClient)

          this.closeModal()

          this.sendToast({
            text: 'Usuário adicionado com sucesso',
            type: 'success'
          })
        })
        .catch((err) => {
          if (err.status === 409) {
            this.sendToast({
              text: 'Este email já está cadastrado',
              type: 'warning'
            })
          } else {
            this.sendToast({
              text: 'Algo de errado aconteceu ao tentar salvar',
              type: 'danger'
            })
          }

          this.isLoading = false
        })
    },
    async editUser () {
      const user = {
        ...this.getterSelectedUser,
        email: this.email,
        name: this.name,
        password: this.password,
        currentPassword: this.currentPassword,
        idUserType: this.idUserType,
        idClient: this.getterAccount.idClient,
        idUserLogged: this.getterAccount.idUser
      }

      this.isLoading = true

      try {
        await this.actionEditUser(user)
        if (this.password.length > 0) {
          await this.actionChangePassword(user)
        }
        this.isLoading = false

        this.closeModal()

        this.sendToast({
          text: 'Usuário alterado com sucesso',
          type: 'success'
        })
      } catch {
        this.isLoading = false
        this.sendToast({
          text: 'Ocorreu um erro ao alterar o usuário',
          type: 'danger'
        })
      }
    },
    removeUser () {
      this.isLoading = true

      this.actionRemoveUser(this.getterSelectedUser.idUser)
        .then(() => {
          this.actionGetAllUsers(this.getterAccount.idClient)

          this.closeModal()

          this.sendToast({
            text: 'Usuário removido com sucesso',
            type: 'success'
          })
        })
        .catch(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Ocorreu um erro ao remover o usuário',
            type: 'danger'
          })
        })
    },
    closeModal () {
      this.dialog = this.isLoading = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
